<template>
  <div class="page-container">
    <span class="total-text">
      <slot name="plus-msg"></slot>共<em>{{ total }}</em>条记录
    </span>
    <div class="pagination-append">
      <el-input v-if="total" class="jump-input" :max="totalPage" v-model="searchPage" @input="checkPageNumber">
        <el-button type="primary" slot="append" class="jump-input-btn" @click="jumpTargetPage">跳转</el-button>
      </el-input>
    </div>
    <el-pagination v-if="total" size="mini" class="page" :current-page="cPage" :page-size="pageSize"
      :page-sizes="pageSizes" layout="slot, sizes, prev, pager, next" :total="total" :pager-count="pagerCount"
      @size-change="changeSize" @current-change="changeCurrent">
      <span class="page-text">显示条数：</span>
    </el-pagination>
  </div>
</template>

<script type="text/javascript">
import { Pagination } from 'element-ui'

export default {
  name: 'Pagination',
  components: {
    'el-pagination': Pagination
  },
  props: {
    pagerCount: {
      type: Number,
      default: 7
    },
    total: {
      type: [Number, String],
      default: 0
    },
    currentPage: {
      type: [Number, String],
      default: 1
    },
    size: Number,
    autoLoad: {
      type: Boolean,
      default: true
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 50, 100]
      }
    }
  },
  data() {
    return {
      pageSize: 20,
      // pageSizes: [10, 20, 50, 100],
      searchPage: ''
    }
  },
  watch: {
    size(nv) {
      this.pageSize = nv
    },
    currentPage(nv) {
      if (nv > 0) {
        this.searchPage = nv
      }
    }
  },
  computed: {
    cPage() {
      return this.currentPage
    },
    totalPage() {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  created() {
    this.pageSize = this.size
    if (this.autoLoad) {
      this.$emit('fn-change')
    }
  },
  methods: {
    jumpTargetPage() {
      if (this.searchPage > this.totalPage) {
        this.searchPage = this.totalPage || 1
      }
      if (this.searchPage < 1) this.searchPage = 1
      this.changeCurrent(Number(this.searchPage))
    },
    changeSize(size) {
      this.$emit('update:size', size)
      this.$emit('update:currentPage', 1)
      this.$emit('fn-change')
    },
    changeCurrent(page) {
      if (page !== 0) {
        this.$emit('update:currentPage', page)
        this.$emit('fn-change')
      }
    },
    checkPageNumber() {
      setTimeout(() => {
        this.searchPage = String(this.searchPage).replace(/\D+/g, '')
        // this.searchPage = String(this.searchPage).replace(/\D+/g, '') || 1
        // if (this.searchPage < 1) {
        //     this.searchPage = 1
        // }
      })
    }
  }
}
</script>
<style lang="sass" scoped>
.total-text
    font-size: 14px
    display: inline-block
    line-height: 40px
    margin-top: 3px
    em
        color: #4B4F58
.page-text
    color: #878a92
    font-size: 14px
.pagination-append
    float: right
    margin-top: 2px
    ::v-deep .el-input
        input
            text-align: center
            padding: 0
.page
    float: right
.jump-input
    width: 100px
    line-height: 30px
    ::v-deep .el-input__inner
        border-radius: 0
        color: #282729
        &:focus
            border-color: #FF3973 !important
            text-align: center
            padding: 0

.jump-input-btn
    color: #fff !important
    width: 50px
    height: 40px
    line-height: 12px
    padding: 10px 0
    background-color: #FF3973 !important
    border-radius: 0
    border: none 0
    &:hover
        background-color: rgba(#FF3973, 0.7) !important
::v-deep .el-pagination
    //pagination reset
    .page-text
        color: #282729
        line-height: 40px !important
    .el-pagination__sizes
        height: 40px
        line-height: 40px
        .el-input__inner
            height: 40px !important
            font-size: 14px
            color: #282729
        .el-select__caret
            color: #282729
            font-size: 20px
            right: 2px
            font-weight: 600
    .number
        color: #282729
        border: 1px solid #C3C6D6
        margin: 0 4px

    .number.active
        border: 1px solid #FF3973
        color: #FF3973

    .el-pager li
        min-width: 40px
        height: 40px
        line-height: 40px

    .el-pager li.active + li
        border-left: 1px solid #C3C6D6

    .btn-prev, .btn-next
        min-width: 40px
        height: 40px
        border: 1px solid #C3C6D6
        padding: 0 4px !important
        margin: 0 4px !important
        .el-icon
            font-size: 16px

    .el-pagination__jump
        margin-left: 18px
</style>
